export enum MutationTypes {
  SET_USERS = "SET_USERS",
  SET_GAME_SESSION = "SET_GAME_SESSION",
  SET_IS_ADMIN = "SET_IS_ADMIN",
  RESET_STORE = "RESET_STORE",
}
